import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import validator from 'validator';
import Swal from 'sweetalert2';
import FooterTrustChat from '../../components/common/FooterTrustChat';
import Input from '../../components/common/InputField';
import ButtonMain from '../../components/common/ButtonMain';
import { forgetPasswordApi } from '../../store/features/forgetPassword';
import SuccessPopup from '../../components/common/SuccessPopup';
import FailurePopup from '../../components/common/FailurePopup';

function MainForget(props) {
  const [stateName, setStateMethod] = useState({
    email: '',
    emailInvalid: false,
    emailInvalidMessage: '',
    FormSubmitting: false,
    emailState: false,
  });
  const [formSubmitted, setFormSubmitted] = useState(false); // 👈 new flag

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);
  const dispatch = useDispatch();
  const { emailFromSignUp } = props;

  const ValidateEmail = (email) => validator.isEmail(email);

  useEffect(() => {
    if (emailFromSignUp?.length > 0) {
      setStateMethod((prev) => ({ ...prev, email: emailFromSignUp }));
    }
  }, [emailFromSignUp]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    if (name === "email") {
      setStateMethod((prev) => ({
        ...prev,
        email: value,
        emailInvalidMessage: "", // 👈 clear while typing
        emailInvalid: false,
        emailState: false,
      }));
      return;
    }

    setStateMethod((prev) => ({ ...prev, [name]: value }));
  };

  const ForgetPasswordHandler = async () => {
    setFormSubmitted(true); // 👈 mark form as submitted

    if (!stateName.email) {
      setStateMethod((prev) => ({
        ...prev,
        emailInvalid: true,
        emailInvalidMessage: t.ENTR_EML_PH, // "Enter email"
        emailState: false,
      }));
      return;
    }

    if (!ValidateEmail(stateName.email)) {
      setStateMethod((prev) => ({
        ...prev,
        emailInvalid: true,
        emailInvalidMessage: t.EMAILERROR, // "Invalid email"
        emailState: false,
      }));
      return;
    }

    // ✅ At this point email is valid
    setStateMethod((prev) => ({
      ...prev,
      emailInvalid: false,
      emailInvalidMessage: "",
      emailState: true,
    }));

    try {
      const action = await dispatch(forgetPasswordApi({ email: stateName.email }));
      const payload = action?.payload;

      if (!payload) {
        return Swal.fire({
          title: "Error",
          text: "Network/Server error. Please try again later.",
          icon: "error",
          confirmButtonColor: "#148dfd",
        });
      }

      const { status, message, error } = payload;

      if (status === 404 && message === "User not found") {
        return Swal.fire({
          title: "Error",
          text: "We could not find an account associated with this email.",
          icon: "error",
          confirmButtonColor: "#148dfd",
        });
      }

      if (status !== 200) {
        return Swal.fire({
          title: "Error",
          text: error || message || "Unexpected error, please try again.",
          icon: "error",
          confirmButtonColor: "#148dfd",
        });
      }

      return Swal.fire({
        title: "Success",
        text: "Reset password email has been sent.",
        icon: "success",
        confirmButtonColor: "#148dfd",
      });
    } catch (err) {
      return Swal.fire({
        title: "Error",
        text: err?.message || "Unexpected error, please try again.",
        icon: "error",
        confirmButtonColor: "#148dfd",
      });
    }
  };

  return (
    <>
      <SuccessPopup />
      <FailurePopup />
      <div className="Forget-main-container">
        <div className="inputDivStyle-forget">
          <div className="textDiv__login">
            <p className="text__create">{t.FORGET_PASSWORD}</p>
            <p className="text__start">{t.FORGET_TEXT}</p>
          </div>
          <Input
            name="email"
            id="email"
            type="email"
            title={t.TITLE_EMAIL}
            placeholder={t.ENTR_EML_PH}
            value={stateName.email}
            onChange={handleChange}
            error={formSubmitted ? stateName.emailInvalidMessage : ""} // 👈 only show after submit
            className={clsx(
              formSubmitted && stateName.emailInvalid && "input__error",
              stateName.emailState && "input__success"
            )}
          />
          <div className="btn-class">
            <ButtonMain
              title={t.BTN_CONTINUE}
              onClick={ForgetPasswordHandler}
              className="buttonStyleEnable"
            />
            <Link to="/login" style={{ textDecoration: "none" }}>
              <ButtonMain title="Back to Login" className="buttonStyleEnable" />
            </Link>
          </div>
        </div>
      </div>
      <FooterTrustChat />
    </>
  );
}

MainForget.propTypes = {
  setSelectForgetState: PropTypes.func.isRequired,
  emailFromSignUp: PropTypes.string.isRequired,
  // Add more prop types as needed
};
export default MainForget;
